import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Agent } from '@amfam/shared/utility/agent';
import { DsModalService } from '@amfam/ui-kit';

@Component({
  selector: 'ds-agent-selection-modal',
  templateUrl: './agent-selection-modal.component.html',
  styleUrls: ['./agent-selection-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AgentSelectionModalComponent implements OnInit {
  @Input() agentSelectionModalId: string;
  @Input() agents: Agent[];
  @Output() agentCancel = new EventEmitter();
  @Output() confirmAgentSelection = new EventEmitter<Agent>();

  modalWidth = '596';
  agentNotificationForm: UntypedFormGroup;
  sendToAgentCopy = 'Send To Agent';

  constructor(
    private modalService: DsModalService,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  open(): void {
    this.modalService.open(this.agentSelectionModalId);
  }

  agentSelection() {
    this.confirmAgentSelection.emit(
      this.agents.filter(
        agent => agent.agentId === this.agentNotificationForm.controls['selectAgent'].value
      )[0]
    );
  }

  close(): void {
    this.modalService.close(this.agentSelectionModalId);
  }

  /**
   * @param: None
   * @returns: void
   * @description: Builds the form and adds the agent select along with the required validation.
   */
  private buildForm(): void {
    this.agentNotificationForm = this.formBuilder.group({
      selectAgent: ['', Validators.compose([Validators.required])]
    });
  }
}
